import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Button, Message } from 'semantic-ui-react';
import {
  showDeleteConfirmation,
  deletePackage,
} from 'state/billingPackage/actions';

export class DeleteConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    const { dispatch } = this.props;
    dispatch(showDeleteConfirmation(false, null, false));
  }

  onConfirm() {
    const { dispatch, packageToDelete } = this.props;
    dispatch(deletePackage(packageToDelete.id));
  }

  render() {
    const { isOpen, isLoading, packageToDelete } = this.props;

    return (
      <Modal open={isOpen} onClose={this.onClose} size="small">
        <Modal.Header>Delete Package</Modal.Header>
        <Modal.Content>
          <Message warning>
            <Message.Header>Are you sure?</Message.Header>
            <p>
              Do you want to delete the package{' '}
              <strong>{packageToDelete && packageToDelete.name}</strong>? This
              action cannot be undone
            </p>
          </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button negative onClick={this.onConfirm} loading={isLoading}>
            Delete
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

DeleteConfirmationModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  packageToDelete: PropTypes.object,
};

DeleteConfirmationModal.defaultProps = {
  isOpen: false,
  isLoading: false,
  packageToDelete: null,
};

const mapStateToProps = state => ({
  isOpen: state.billingPackage.deleteConfirmation.isOpen,
  isLoading: state.billingPackage.deleteConfirmation.isLoading,
  packageToDelete: state.billingPackage.deleteConfirmation.packageToDelete,
});

export default connect(mapStateToProps)(DeleteConfirmationModal);
